import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Box,
  CircularProgress,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const FormModal = ({
  open,
  onClose,
  title,
  children,
  onSave,
  saveLabel,
  cancelLabel,
  loading,
  maxWidth,
  fullWidth,
  disableSave,
  hideActions,
}) => {
  const handleSave = async () => {
    if (onSave) {
      await onSave();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      aria-labelledby="form-modal-title"
    >
      <DialogTitle id="form-modal-title">
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          {title}
          <IconButton
            aria-label="close"
            onClick={onClose}
            disabled={loading}
            sx={{
              color: 'grey.500',
              '&:hover': {
                color: 'grey.700',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        {children}
      </DialogContent>

      {!hideActions && (
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={onClose}
            disabled={loading}
            color="inherit"
          >
            {cancelLabel}
          </Button>
          <Button
            onClick={handleSave}
            variant="contained"
            disabled={loading || disableSave}
            startIcon={loading && <CircularProgress size={16} />}
          >
            {loading ? 'Saving...' : saveLabel}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

FormModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onSave: PropTypes.func,
  saveLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  loading: PropTypes.bool,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  fullWidth: PropTypes.bool,
  disableSave: PropTypes.bool,
  hideActions: PropTypes.bool,
};

FormModal.defaultProps = {
  onSave: null,
  saveLabel: 'Save',
  cancelLabel: 'Cancel',
  loading: false,
  maxWidth: 'sm',
  fullWidth: true,
  disableSave: false,
  hideActions: false,
};

export default FormModal;
